<template>
    <ul class="tree-container" v-if="internalTreeData">
      <VueDraggable
        v-model="internalTreeData"
        animation="150"
        ghostClass="ghost"
        @end="handleDrop"
        @move="handleMove"
        class="draggable-list"
        group="fileSystem"
        :sort = false
      >
      <li v-for="item in internalTreeData" 
      :key="item.key" class="item" :id="item.key">
      <div  @click="handleItemClick(item); clickedItem = item.key; console.log(clickedItem)" 
      @dblclick="loadEmailDetails(item.key)"
      @dragenter="handleMove"
      @contextmenu.prevent="openContextMenu($event, item)"
      :id="item.key" class="innerItem" :class="{clicked: clickedItem == item.key}">
        <span :id="item.key"
        v-if="item.type == 'folder' && hoveredKey !== item.key" 
        class="material-icons">
          folder</span>
        <span :id="item.key"
        v-if="item.type == 'folder' && hoveredKey == item.key" 
        class="material-icons">
          folder_open</span>
        <span :id="item.key"
        v-else-if="item.type == 'email'" 
        class="material-icons">
          article</span>
          <span class="itemTitle" :id="item.key">{{item.label}}</span>
      </div>
    </li>
    </VueDraggable>
   
  </ul>
    <div v-else>No data</div>
    <ContextMenu v-if="isContextMenuVisible"
                  @delete = 'showConfirmationModal = true'
                  @openItem = 'handleItemClick(selectedItem)' 
                  @close = "isContextMenuVisible = false"
                 :contextItem="selectedItem"
                 :style="{ top: menuY -490 + 'px', left: 10 + 'px' }"/>
    <ConfirmationModal v-if="showConfirmationModal"
                :Header="'Mail Löschen'"
                :MainText="`Wollen Sie ${selectedItem.label} ${selectedItem.type == 'folder'? 'mit allen Inhalten' : '' } wirklich löschen?`"
                @confirm = "deleteItem (selectedItem.key), showConfirmationModal = false"
                @close = "showConfirmationModal = false"
    />         
  </template>
  
  <script>
  import { useStore } from 'vuex';
  import { ref, watch, onMounted} from 'vue';
  import { VueDraggable } from 'vue-draggable-plus';
  import { buildTreeData } from '@/utils/treeHelpers/buildTreeData';
  import { buildEmailFromDb } from '@/utils/db/buildEmailFromDb';
  import  ContextMenu  from '../Reusables/Feedback/ContextMenu.vue';
  import ConfirmationModal from '../Reusables/Feedback/ConfirmationModal.vue';
  
  export default {
    name: "FSDbTree",
    components: { VueDraggable, ContextMenu, ConfirmationModal },
    props: {
      level: Number,
      treeData: Array,
      hoveredPathItem: Object
    },
    emits: ["moveItem", "selectItem", "openItem", "deleteItem"], // 🔹 Korrekte Events registrieren
    setup(props, { emit }) {
      const hoveredKey = ref(null);
      const internalTreeData = ref(props.treeData);
      const store = useStore();
      const isContextMenuVisible = ref(false);
      const showConfirmationModal = ref(false);
      const menuX = ref(0);
      const menuY = ref(0);
      const selectedItem = ref(null);
      const clickedItem = ref(null)

      const openContextMenu = (event, item) => {
        event.preventDefault();
        selectedItem.value = item;
        menuX.value = event.clientX;
        menuY.value = event.clientY;
        isContextMenuVisible.value = true;
        console.log(menuY.value, isContextMenuVisible.value)
      };

      const closeContextMenu = () => {
        isContextMenuVisible.value = false;
      };

      onMounted(() => {
      document.addEventListener('click', closeContextMenu);
      });
      
      watch(() => props.treeData, (newData) => {
      internalTreeData.value = [...newData]; 
        }, { deep: true });

      const handleDrop = async (event) => {
        //if (props.hoveredPathItem?.key == 'root') return
        const draggedItemKey = event.data.key;
        const newParentKey = hoveredKey.value;
        const item = internalTreeData.value.find((element) => element.key == draggedItemKey);
        if(props.hoveredPathItem){
          emit('moveItem', item, props.hoveredPathItem); 
          console.log(`📌 Element ${draggedItemKey} wurde in ${props.hoveredPathItem.key} verschoben.`);
        }
        if (!newParentKey && !props.hoveredPathItem || 
            !newParentKey.startsWith('folder') ||
             newParentKey == draggedItemKey) return;
        const newParent = internalTreeData.value.find((element) => element.key == newParentKey);
        hoveredKey.value = null;
        emit('moveItem', item, newParent); 
        console.log(`📌 Element ${draggedItemKey} wurde in ${newParentKey} verschoben.`);
        
      };

      const handleMove = (event) => {
        console.log(event.target.getAttribute("id"))
        if(event.target.getAttribute("id") && event.target.getAttribute("id") !== null ){
          hoveredKey.value = event.target.getAttribute("id")
        } 
      }
  
      const toggleMetaInfo = (item, type) => {
        if (type !== 'email') return;
        emit('selectItem', item.id);
      };

      const handleItemClick = async (item) =>{
        if (item.type == 'folder'){
          emit('openItem', item);
        }else {
          try {
          const {reconstructedJson} = await buildEmailFromDb(item.id);
          store.commit('setPreviewData', reconstructedJson)
          console.log(store.state.previewData)
          } catch (error) {
          console.error('Fehler beim Laden der Mail-Details:', error);
        }
        }
      }

      // Lade die Mail-Details bei Doppelklick
      const loadEmailDetails = async (key) => {
        if(!key.startsWith('email')) return
        const emailId = key.split('-')[1]
        try {
          // Hier die asynchrone Funktion `getDbMails` im Vuex-Store oder direkt importiert aufrufen
            const {reconstructedJson, placeholders, mediaQueries} = await buildEmailFromDb(emailId);
            store.dispatch('updateEmailData', reconstructedJson)
            store.dispatch('updateEmailTitle', reconstructedJson.title)
            if(placeholders && Object.keys(placeholders).length) store.dispatch('updateXPathPlaceholders', placeholders)
            store.dispatch('saveMediaQueries', mediaQueries)
        } catch (error) {
          console.error('Fehler beim Laden der Mail-Details:', error);
        }
      };

      // API: Lade E-Mails & Ordner
      const fetchData = async () => {
            try {
                const response = await fetch(`https://html-creator.demo.cartago.com/api/folders/folderLevel/${props.level}`);
                const data = await response.json();  
                const emails = data.emails;  
                const folders = data.folders; 

                internalTreeData.value = buildTreeData(emails, folders);
            } catch (error) {
                console.error('Fehler beim Laden der Daten:', error);
            }
        };
      
      const deleteItem = (key) => {
          isContextMenuVisible.value = false
          emit('deleteItem', key)
      }
        
        
        ;
        
      return {
        internalTreeData,
        hoveredKey,
        internalTreeData,
        handleDrop,
        handleMove,
        toggleMetaInfo,
        loadEmailDetails,
        fetchData,
        handleItemClick,
        isContextMenuVisible,
        showConfirmationModal,
        menuX, 
        menuY, 
        selectedItem, 
        clickedItem,
        openContextMenu,
        deleteItem
      };
    }
  };
  </script>
  
  <style scoped>
  .tree-container {
    list-style-type: none;
    padding-left: 10px;
  }
  
  .item {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 5px;
    transition: background-color 0.2s;
  }

  .innerItem{
    font-size: 15px; 
    width: 95%;     
  }

  .itemTitle{
    white-space: nowrap;   
    overflow: hidden;     
    text-overflow: ellipsis; 
  }

  .innerItem:hover{
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }

  .clicked {
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }

  .innerItem .material-icons{
    font-size:20px;
    background-color:#2c3e50;
    padding: 7px;
    border-radius: 100%;
    color: white;
  }
  
  .tree-node:hover {
    background-color: #f0f0f0;
  }
  
  .folder {
    font-weight: bold;
  }
  
  .nested-list {
    padding-left: 20px;
  }
  
  .material-symbols-outlined {
    margin-right: 8px;
  }

  ul {
list-style-type: none;
padding-left: 20px;
}

li div {
cursor: pointer;
display: flex;
align-items: center;
}

.material-icons {
margin-right: 8px;
}
  </style>
  